import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { Driver, Result } from 'neo4j-driver';
import * as neo4j from 'neo4j-driver';
import { Subject } from 'rxjs';
@Injectable()
export class KeySlService {
  private driver: Driver;
  public currentApiKey: any = null;

  private graphUpdateSource = new Subject<any>();
  graphUpdate$ = this.graphUpdateSource.asObservable();

  triggerGraphUpdate(
    customerId: string,
    apiUsed: string,
    selectedNodeLabel: string
  ) {
    this.graphUpdateSource.next({ customerId, apiUsed, selectedNodeLabel });
  }

  constructor(private http: HttpClient, private envService: EnvService) {}

  keySocialLink = `${this.envService.URL_API_V1}/socialLinkKey`;
  apiSocialLink = `${this.envService.URL_API_V1}/apiSocialLinkKey`;

  /////////////////////
  // Key Social Link //
  /////////////////////
  createSocialLinksKeys(data) {
    return this.http.post(`${this.keySocialLink}/create`, data);
  }

  getSocialLinksKeys() {
    return this.http.get(`${this.keySocialLink}/getAll`);
  }
  getSocialLinksKeysAndSet() {
    new Promise((resolve) => {
      this.http.get(`${this.keySocialLink}/getAll`).subscribe({
        next: (currentApiKey: any) => {
          this.currentApiKey = currentApiKey;
          localStorage.setItem(
            'currentApiKey',
            JSON.stringify(currentApiKey[0]?._id)
          );

          resolve(true);
        },
        error: (err) => {
          console.log(err);
          resolve(false);
        },
      });
    });
  }
  getSocialLinkKeyById(id) {
    return this.http.get(`${this.keySocialLink}/get/${id}`);
  }
  updateSocialLinkKey(id, data) {
    return this.http.put(`${this.keySocialLink}/update/${id}`, data);
  }
  deleteSocialLinkKey(id, key) {
    return this.http.put(`${this.keySocialLink}/delete/${id}`, key);
  }
  /////////////////////
  // Api Social Link //
  /////////////////////
  createApiSocialLinks(data) {
    return this.http.post(`${this.apiSocialLink}/create`, data);
  }
  getApiSocialLinks() {
    return this.http.get(`${this.apiSocialLink}/getAll`);
  }
  getApiSocialLinkActive() {
    return this.http.get(`${this.apiSocialLink}/getApiSocialLinkActive`);
  }
  getApiSocialLinkByCategory(category) {
    return this.http.get(`${this.apiSocialLink}/getApiSocialLinkByCategory`, {
      params: { category },
    });
  }

  getApiSocialLinkById(id) {
    return this.http.get(`${this.apiSocialLink}/get/${id}`);
  }
  updateApiSocialLink(id, data) {
    return this.http.put(`${this.apiSocialLink}/update/${id}`, data);
  }
  deleteApiSocialLink(id, api) {
    return this.http.put(`${this.apiSocialLink}/delete/${id}`, api);
  }
  requestApiSocialLink(apiId, userParams, apiKeyId) {
    return this.http.put(
      `${this.apiSocialLink}/request/${apiId}/${apiKeyId}`,
      userParams
    );
  }

  /////////////////////
  // Api consulta Cypher //
  /////////////////////

  // Ejecutar una consulta Cypher
  async runQuery(query: string, params: any): Promise<Result> {
    console.log(query, params);

    // const session: Session = this.driver.session();
    let env = new EnvService();
    // Create a new Neo4j driver and session
    this.driver = neo4j.driver(
      env.URL_NEO4J,
      neo4j.auth.basic('neo4j', '12341234')
    );
    let session = this.driver.session();

    try {
      const result: any = await session.run(query, params);
      console.log(result);

      return result;
    } finally {
      await session.close();
    }
  }

  // Actualizar el grafo
  updateGraph() {
    // Aquí puedes llamar a la lógica de NeoVis para actualizar el grafo
    console.log('Grafo actualizado');
  }

  async updateGraphWithDynamicLabel(
    selectedNodeLabel: string,
    dynamicLabel: string,
    customerId: string,
    params: any
  ) {
    const query = `
      MATCH (c:\`${selectedNodeLabel}\` {id: $customerId})
      MERGE (t:\`${dynamicLabel}\` {id: $properties.id})
      ON CREATE SET t += $properties
      MERGE (c)-[r:HAS_${dynamicLabel.toUpperCase().replace(/ /g, '_')}]->(t)
      SET r.since = datetime()
      SET r.type = '${dynamicLabel}'
        SET r.value = 6
      
      RETURN c AS c1, NULL AS a, r, NULL AS r2, t AS a2
    `;

    await this.runQuery(query, {
      customerId,
      properties: params.properties,
    });

    console.log(
      `Nodo y relación con etiqueta dinámica (${dynamicLabel}) añadidos.`
    );
  }
}
